module.exports = __webpack_public_path__ + "media/images/stores_page-c312e07d947ac4fb177073067af76fdf.jpg";